import API from './api';

export default class Step extends API {
  constructor(config = {}) {
    config.path = `quizzes/${config.quizId}/steps`;

    super(config);
  }

  ordinate(resource = '', data, config = {}) {
    return this.put(`${resource}/ordinate`, data, config);
  }

  duplicate(resource = '', data = {}, config = {}) {
    return this.post(data, config, `${resource}/duplicate`);
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/request/step.js
 **/